module.exports = __webpack_public_path__ + "img/room-1.15c32060.jpg";